var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"btn btn-lg btn-primary contact-us-cta",attrs:{"to":{ name: _vm.routes.CONTACT_PAGE }}},[_c('oc-content',{attrs:{"item":_vm.$oc.content.sharedContactUsCtaLabel}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }